import { SvgIconProps } from "@mui/material";
import { FC } from "react";

export const CheckBoxIcon: FC<SvgIconProps> = ({
    width = 20,
    height = 20,
    stroke = "#D8D8D8",
    ...rest
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox={"0 0 20 20"}
            fill={"none"}
            xmlns={"http://www.w3.org/2000/svg"}
            {...rest}
        >
            <g clipPath={"url(#clip0_27_529)"}>
                <rect x={"0.5"} y={"0.5"} width={"19"} height={"19"} rx={"2.5"} stroke={stroke} />
            </g>
            <defs>
                <clipPath id={"clip0_27_529"}>
                    <rect width={"20"} height={"20"} fill={"white"} />
                </clipPath>
            </defs>
        </svg>
    );
};
